export default "__VITE_ASSET__KfXzm0aZ__"